import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

// High & Low do Silverlight (FML.HighLow): 2 MAs aritméticas (máximas/mínimas)
// como overlay de preço. ≠ HighLowSeries (HHV/LLV) — accessors .high/.low.
class HighLowMaSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorHigh = this.yAccessorHigh.bind(this);
    this.yAccessorLow = this.yAccessorLow.bind(this);
  }

  yAccessorHigh(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).high;
  }

  yAccessorLow(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).low;
  }

  render() {
    const {
      className,
      strokeHigh,
      strokeLow,
      highlightOnHover,
      onDoubleClick,
      onContextMenu,
    } = this.props;

    return (
      <g className={className} style={{ cursor: "pointer" }}>
        <LineSeries
          yAccessor={this.yAccessorHigh}
          stroke={strokeHigh}
          fill="none"
          highlightOnHover={highlightOnHover}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorLow}
          stroke={strokeLow}
          fill="none"
          highlightOnHover={highlightOnHover}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

HighLowMaSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  strokeHigh: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  strokeLow: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  highlightOnHover: PropTypes.bool,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

HighLowMaSeries.defaultProps = {
  className: "react-stockcharts-highlowma-series",
  // Cores default = engine Silverlight (2 séries sem SetAttrs: Yellow/Red).
  strokeHigh: { color: "#FFFF00" },
  strokeLow: { color: "#FF0000" },
  highlightOnHover: true,
};

export default HighLowMaSeries;
